import AmigoHeader from './AmigoHeader';
import { HeaderWrapper } from './Header.styles';
import { HeaderProps } from './Header.types';
import VodafoneHeader from './VodafoneHeader';

export default function Header({ isAmigo, login }: HeaderProps) {
    return (
        <HeaderWrapper>{isAmigo ? <AmigoHeader loginProps={login} /> : <VodafoneHeader login={login} />}</HeaderWrapper>
    );
}
